import React, { Component } from 'react';
import { toast } from 'react-toastify';
import {Button, Dialog, TextField} from '@betareader/design-system';
import { withRouter } from 'react-router-dom';

import { withTranslation } from 'react-i18next';
import styled from 'styled-components';

// redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { uxAnalyticsUtil, productCapUtil } from '../../../utils';
import { MediaQuery } from '../../../constants/size';

const ButtonWrapper = styled.div`
  ${MediaQuery.tablet} {
    float: right;
  }
  display: flex;
  flex-direction: column;
`;

export class InviteAccountMemberModal extends Component {
  constructor(props) {
    super(props);
    this.state = {email: '', isSendingInvite: false, open: false};
  }

  handleEmailChange = event => {
    this.setState({
      email: event.target.value
    });
  }

  sendInvite = async event => {
    event?.preventDefault();
    const { idToken, userProfile, t } = this.props;
    const { email } = this.state;
    try {
      this.setState({
        isSendingInvite: true
      });
      const response = await fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}/accounts/${userProfile.account._id}/invitations`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'br-token': idToken
          },
          body: JSON.stringify({
            email
          })
        });
      const body = await response.json();
      if (body.err || !response.ok) {
        toast.error(t(body.msg || 'SomethingWentWrong'));
      } else {
        toast.info(t('InvitationSent'));
      }
    } catch (e) {
      toast.error(t('SomethingWentWrong'));
    } finally {
      this.setState({email: '', isSendingInvite: false});
    }
  };

  closeModal = () => this.setState({ open: false });

  openModal = () => {
    uxAnalyticsUtil.trackModalView('invite-account-member');
    this.setState({ open: true });
  };

  render() {
    const { t, userProfile } = this.props;
    const { email, isSendingInvite, open } = this.state;
    const canInviteAccountMembers = productCapUtil.canInviteAccountMembers({ userProfile });
    return (
      <React.Fragment>
        <ButtonWrapper>
          <Button
            disabled={!canInviteAccountMembers}
            onClick={this.openModal}
          >{t('InviteUser')}</Button>
          {
            !canInviteAccountMembers && (
              <span style={{ fontWeight: 'light', fontSize: '0.8em', fontStyle: 'italic' }}>
                {t('UpgradeToUnlock')}
              </span>
            )
          }
        </ButtonWrapper>
        <Dialog
          open={open}
          onClose={this.closeModal}
          title={t('InviteUser')}
          actions={<>
            <Button variant='secondary' onClick={this.closeModal} disabled={isSendingInvite}>
              {t('Cancel')}
            </Button>
            <Button type='submit' form='invite-account-member-form'
              disabled={!email || isSendingInvite} aria-busy={isSendingInvite}>
              {t('Send')}
            </Button>
          </>}
        >
          <form id='invite-account-member-form' onSubmit={this.sendInvite}>
            <TextField id='invite-account-member-email' label={t('Email')}
              type='email' required value={email} onChange={this.handleEmailChange} />
            <p>{t('InvitedMembersMsg')}</p>
          </form>
        </Dialog>
      </React.Fragment>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile
});

const mapDispatchToProps = dispatch => bindActionCreators({
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(InviteAccountMemberModal)));
